import React from "react"

const wrapImage = (align, width, image) => {
  if (align) {
    return <figure style={{"float": align}} className="inline"><img width={width} srcSet={image.srcSet} /></figure>
  } else {
    return <figure className="inline"><img width={width} srcSet={image.srcSet} /></figure>
  }
}

const wrapImageList = (srcImages) => {
  const imgs = {}
  if (srcImages) {
    srcImages.forEach((image, i) => {
      imgs[`Img${i + 1}`] = ({ align, width }) => wrapImage(align,width,image)
    });
  }
  return imgs;
}

export default wrapImageList